import _ from 'lodash';
import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';

class DefaultCheckBox extends Component {

    render() {

        const inputValue = _.get(this.props, 'input.value', false);
        const checked = (
            inputValue === true ||
            inputValue === 'true' ||
            inputValue === 1 ||
            inputValue === '1'
        );

        return (
            <Checkbox
                className={ _.get(this.props, 'classes', '') }
                label={ this.props.label }
                toggle={this.props.toggle || false}
                checked={ checked }
                onChange={ (e, data) => { this.props.input.onChange(data.checked) } }
            />
        );

    }
}

export default DefaultCheckBox;